import analyticsTrack from '@lib/analytics/analyticsTrack';

export interface ITrackDesignerSelected {
  id: string;
  firstName: string;
  lastName: string;
  soonestWeekAvailable: number;
  position?: number;
  listId?: string;
}

/**
 * @deprecated - do not use ops-client shit
 */
export default function trackDesignerSelected(
  {
    firstName, lastName, soonestWeekAvailable, position, listId
  }: ITrackDesignerSelected
) {
  analyticsTrack('designer_select', {
    availability: Number(soonestWeekAvailable),
    designer_name: `${firstName} ${lastName}`,
    position: position ?? null,
    list_id: listId ?? null
  });
}
